export default __webpack_public_path__ + "static/media/smilies03.f2471a11.png";